import React from 'react';
import { useTranslation } from 'react-i18next';
import { Truck, User, Phone, FileText } from 'lucide-react';
import DetailTile from './DetailTile';
import { getPropertyValue } from '../../../services/traceability-api';

const DispatchView = ({ isMobile, data }) => {
    const { t } = useTranslation();
    
    const properties = data?.properties || [];
    
    const vehicleNo = getPropertyValue(properties, 'Vehicle No') 
        || getPropertyValue(properties, 'Vehicle Number') || '—';
    const driver = getPropertyValue(properties, 'Driver') || '—';
    const driverPhone = getPropertyValue(properties, 'Driver Phone') || '—';
    const dispatchNote = getPropertyValue(properties, 'Dispatch Note') || '—';

    return (
        <div className="animate-fade-in p-0">
            <div className="trace-banner info">
                <div className="side-line"></div>
                <div className="d-flex align-items-center gap-2">
                    <Truck size={16} />
                    <p style={{ margin: 0 }}>Dispatched</p>
                </div>
            </div>

            <div className="row g-3">
                <DetailTile isMobile={isMobile} icon={<Truck size={16} />} title="Vehicle No" value={vehicleNo} />
                <DetailTile isMobile={isMobile} icon={<User size={16} />} title="Driver" value={driver} />
                <DetailTile isMobile={isMobile} icon={<Phone size={16} />} title="Driver Phone" value={driverPhone} />
                <DetailTile isMobile={isMobile} icon={<FileText size={16} />} title="Dispatch Note" value={dispatchNote} />
            </div>
        </div>
    );
};

export default DispatchView;
